import { type ReadonlyURLSearchParams } from 'next/navigation';

import { ANALYTICS_URL_PARAMS } from '@/lib/analytics/const';
import {
	CP_ETA_PARAM,
	ETA_LOCATION_PARAM,
	MODEL_YEAR_PARAM,
	OPPORTUNITY_ID_PARAM,
	OPPORTUNITY_ORIGIN_PARAM,
	TAX_RATE_PARAM,
	VIN_PARAM
} from '@/lib/order/utils/constants';

const ALWAYS_KEEP_SEARCH_PARAMS: readonly string[] = [
	'mode',
	'business-type',
	'use-case',
	ANALYTICS_URL_PARAMS.journeyId,
	OPPORTUNITY_ID_PARAM,
	OPPORTUNITY_ORIGIN_PARAM,
	TAX_RATE_PARAM
];

const SEAC_SEARCH_PARAMS: readonly string[] = [MODEL_YEAR_PARAM, VIN_PARAM, CP_ETA_PARAM, ETA_LOCATION_PARAM];

/**
 * Creates a string of all the url params we want to persist for Config flow
 * @param searchParams - The current search params
 * @returns a string of the search params to persist in the url
 */
export function paramsToPersistForConfig(searchParams: ReadonlyURLSearchParams) {
	const searchParamsToPersist = [];

	for (const key of searchParams.keys()) {
		if (ALWAYS_KEEP_SEARCH_PARAMS.includes(key)) {
			searchParamsToPersist.push(`${key}=${searchParams.get(key)}`);
		}
	}

	return searchParamsToPersist.join('&');
}

/**
 * Creates a string of all the url params we want to persist for SEAC flow
 * @param searchParams - The current search params
 * @returns a string of the search params to persist in the url
 */
export function paramsToPersistsForSEAC(searchParams: ReadonlyURLSearchParams) {
	const searchParamsToPersist = [];

	for (const key of searchParams.keys()) {
		if (ALWAYS_KEEP_SEARCH_PARAMS.includes(key)) {
			searchParamsToPersist.push(`${key}=${searchParams.get(key)}`);
		}

		if (SEAC_SEARCH_PARAMS.includes(key)) {
			searchParamsToPersist.push(`${key}=${searchParams.get(key)}`);
		}
	}

	return searchParamsToPersist.join('&');
}
